export default {

    tagihan() {
        var url = "history/get-status-bayar-bulan-ini";
        return url;
    },
    ReqBayar() {
        var url = "bayar/req-bayar";
        return url;
    },
    ReqBayarVA() {
        var url = "bayar/req-bayar-va";
        return url;
    },
    ReqBayarEwallet() {
        var url = "bayar/req-bayar-ewallet";
        return url;
    },
    ReqBayarRetail() {
        var url = "bayar/req-bayar-retail";
        return url;
    },
    ReqBayarRetailIndomaret() {
        var url = "bayar/req-bayar-indomaret";
        return url;
    },
    
    BatalBayar() {
        var url = "bayar/batalin";
        return url;
    },
    Profil() {
        var url = "profil/get";
        return url;
    },
    Bulanini() {
        var url = "history/get-status-bayar-bulan-ini";
        return url;
    },
    Bantuan() {
        var url = "admin/teknisi-list";
        return url;
    },
    BantuanSave() {
        var url = "report/save";
        return url;
    },
    History() {
        var url = "history/pembayaran";
        return url;
    },
    Tagihan() {
        var url = "history/tagihan-cek";
        return url;
    },
    Pengaduan() {
        var url = "pengaduan/list";
        return url;
    },
    PengaduanDetail() {
        var url = "pengaduan/detail";
        return url;
    },
    Pengumuman() {
        var url = "pengumuman/list";
        return url;
    },
    Internet() {
        var url = "profil/internet";
        return url;
    },
    Slider() {
        var url = "slider/list";
        return url;
    },
    Login() {
        var url = "login/submit";
        return url;
    },
    IsolirOwner() {
        var url = "admin/owner";
        return url;
    },
    getInfoModem() {
        var url = "modem/info";
        return url;
    },

    /* ACS */
    getIndexAcs() {
        var url = "index.php";
        return url;
    },
    getListWifi() {
        var url = "list-wifi.php";
        return url;
    },
    getListDevice() {
        var url = "list-device.php";
        return url;
    },
    updateDevice() {
        var url = "ganti-password.php";
        return url;
    },
    /* END ACS */


    /* NO LOGIN PART */
    TagihanNoLogin() {
        var url = "history/tagihan-cek-nl";
        return url;
    },
    
}


// WEBPACK FOOTER //
// ./src/Interface.js